import React, { useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import countriesData from "../../data/countries.json";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { generateEventId, trackLeadSubmission } from '../../utils/analytics';

export default function ContactForm() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    subject: "",
    message: "",
  });

  // Handler for input field changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    // Generate unique event ID for Meta Pixel ⇔ CAPI deduplication
    const eventId = generateEventId();
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/contact`,
        {
          ...formData,
          event_id:  eventId,
          form_type: 'contact_us_page',
        }
      );
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Thank You for Contacting Us!',
          text: 'Our team will connect with you shortly to assist you.',
        });

        // Push dataLayer event for GTM → Meta Pixel deduplication
        trackLeadSubmission('contact_us_page', eventId, {
          name:  formData.name,
          email: formData.email,
          phone: formData.phone,
        });
  
        setFormData({
          name:    "",
          email:   "",
          phone:   "",
          address: "",
          subject: "",
          message: "",
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error occurred while sending data. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };
  const handleKeyPress = (event) => {
    const charCode = event.charCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };

  return (
    <div className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30">
      <form
        onSubmit={onSubmit}
        className="row st-contact-form st-type1"
        method="post"
        id="contact-form"
      >
        <div className="row">
          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">Full Name</label>
            <input
              type="text"
              className="cs_form_field"
              id="name"
              name="name"
              placeholder="Your Full Name"
              onChange={handleInputChange}
              value={formData.name}
              required
            />
            <div className="cs_height_42 cs_height_xl_25" />
          </div>

          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">Address</label>
            <input
              type="text"
              className="cs_form_field"
              placeholder="Your address"
              id="address"
              name="address"
              required
              onChange={handleInputChange}
              value={formData.address}
            />
            <div className="cs_height_42 cs_height_xl_25" />
          </div>

          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">Email</label>
            <input
              type="email"
              className="cs_form_field"
              id="email"
              name="email"
              placeholder="example@email.com"
              onChange={handleInputChange}
              value={formData.email}
              required
            />
            <div className="cs_height_42 cs_height_xl_25" />
          </div>

          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">
              Mobile Number
            </label>
            <PhoneInput
              country={'in'}
              enableSearch={true}
              value={formData.phone}
              onChange={(phone) => setFormData({ ...formData, phone: '+' + phone })}
              inputClass="cs_form_field"
              inputStyle={{ width: '100%', height: '56px', borderRadius: '30px', paddingLeft: '48px' }}
              buttonStyle={{ borderRadius: '30px 0 0 30px', backgroundColor: 'transparent', border: 'none', paddingLeft: '10px' }}
              containerStyle={{ width: '100%' }}
            />
            <div className="cs_height_42 cs_height_xl_25" />
          </div>


          <div className="col-lg-12">
            <label className="cs_input_label cs_heading_color">Subject</label>
            <input
              type="text"
              id="subject"
              name="subject"
              className="cs_form_field"
              placeholder="Your subject"
              required
              onChange={handleInputChange}
              value={formData.subject}
            />
            <div className="cs_height_42 cs_height_xl_25" />
          </div>

          <div className="col-lg-12">
            <label className="cs_input_label cs_heading_color">Message</label>
            <textarea
              cols={30}
              rows={4}
              id="message"
              name="message"
              className="cs_form_field"
              placeholder="Write something..."
              onChange={handleInputChange}
              value={formData.message}
            />
            <div className="cs_height_42 cs_height_xl_25" />
          </div>

          <div className="col-lg-12">
            <div className="cs_height_18" />
            <button
              className="cs_btn cs_style_1"
              type="submit"
              id="submit"
              name="submit"
            >
              <span>{loading ? "Sending..." : "Send Message"}</span>
              <i>
                <img src="/images/icons/arrow_white.svg" alt="Icon" />
                <img src="/images/icons/arrow_white.svg" alt="Icon" />
              </i>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
